// @ts-check
/**
 * @prettier
 */
import moment from 'moment';

/**
 * Converts a date to a string in the following format: 'MMMM Do, YYYY'
 * or classic US. Date format.
 * @param {Date} date
 * @return {string}
 */
export const dateToLastUpdateDateString = date => moment(date).format('MMMM Do, YYYY');

/**
 * Get's the latest update date from a draft
 * @param {Object} draft
 * @param {Array<{updated_at: string}>} draft.customizations
 * @return {Date}
 */
export const getLastUpdatedDate = ({ customizations }) => {
  const [lastUpdate] = customizations
    .map(customization => new Date(customization.updated_at))
    .sort((a, b) => +b - +a);
  return lastUpdate;
};



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/tools/dateTools.js